export enum CallActions {
  Answer = 'verto.answer',
  Attach = 'verto.attach',
  Invite = 'verto.invite',
  Bye = 'verto.bye',
  Modify = 'verto.modify',
  Info = 'verto.info',
  Ready = 'verto.clientReady',
  Event = 'verto.event',
  Punt = 'verto.punt',
  Media = 'verto.media',
  Display = 'verto.display',
  Subscribe = 'verto.subscribe',
  Unsubscribe = 'verto.unsubscribe',
  Broadcast = 'verto.broadcast'
}